<template>
  <div class="router">
    <div class="left">
      <!-- 数量统计 -->
      <div class="number">
        <keep-alive v-for="(val, key) in list" :key="key">
          <number
            :title="val.title"
            :tag="val.tag"
            :number="val.number"
            :color="val.color"
          ></number>
        </keep-alive>
      </div>
    </div>
    <div class="right">
      <!--实时监控-->
      <keep-alive>
        <cpu></cpu>
      </keep-alive>
      <!--服务器信息统计-->
      <keep-alive>
        <Index />
      </keep-alive>
    </div>
  </div>
</template>

<script>
  import Index from '../../components/server/index'
  import number from '../../components/number.vue'
  import Cpu from '../../components/server/cpu'

  export default {
    components: {
      Cpu,
      number,
      Index,
    },
    name: 'index',
    data() {
      return {
        list: [
          { title: '注册用户', tag: '昨', number: 20, color: '#5fb877' }
        ],
      }
    },
    created() {
      this._request()
    },
    methods: {
      _request() {
        this.$request('console').then((res) => {
          if (res.error_code === 10000) {
            this.list = res.data
          }
        })
      },
    },
  }
</script>

<style lang="less">
  .router {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left {
      width: 60%;
      .number {
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        justify-content: space-between;
        .card {
          width: 21.5%;
          &:last-child {
            margin-right: 0px;
          }
        }
      }
    }
    .right {
      width: 38%;
    }
  }
</style>
